import { render, staticRenderFns } from "./gj-empty.vue?vue&type=template&id=12182832&scoped=true&"
import script from "./gj-empty.vue?vue&type=script&lang=js&"
export * from "./gj-empty.vue?vue&type=script&lang=js&"
import style0 from "./gj-empty.vue?vue&type=style&index=0&id=12182832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12182832",
  null
  
)

export default component.exports